/**
 * Os seis cenarios do fim de semana.
 *
 * TITULOS PROVISORIOS. O proprio roteiro de 19/10 avisa: "esses seis titulos
 * precisam ser ajustados aos cenarios reais quando fechar os casos". O grupo
 * decidiu publicar assim mesmo, porque eles ja comunicam o escopo, e trocar
 * um titulo depois custa uma linha.
 *
 * Cada titulo nomeia a falha que o cenario explora, nao o caso clinico. E
 * proposital: a reuniao de 14/10 pediu cautela para nao expor o escopo
 * completo no site e facilitar a copia, e revelar o caso estraga a surpresa
 * de quem vai atuar.
 */
export const cenarios: { titulo: string; texto: string }[] = [
  {
    titulo: 'Quando a informação não chega',
    texto: 'Comunicação e transferência segura de informações.',
  },
  {
    titulo: 'Quando a hierarquia pesa',
    texto: 'Assertividade, speaking up e escalonamento de preocupações.',
  },
  {
    titulo: 'Quando o cenário muda',
    texto: 'Consciência situacional e antecipação de riscos.',
  },
  {
    titulo: 'Quando cada um sabe uma parte',
    texto: 'Coordenação multiprofissional e modelo mental compartilhado.',
  },
  {
    titulo: 'Quando é preciso decidir sob pressão',
    texto: 'Liderança, priorização e tomada de decisão.',
  },
  {
    titulo: 'Quando algo não sai como esperado',
    texto: 'Resposta da equipe, comunicação e aprendizagem.',
  },
];

/** O fecho do bloco. Diz o que separa esta imersao de assistir a um caso. */
export const convite = 'Você não vai assistir a seis casos. Vai fazer parte deles.';
